import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const refreshPaypal = () => {
    return axiosPrivate.post(`/dashboard/api/v1/paypal_onboarding/check_onboarding`)
}